import axios from 'axios'

// API base URL - automatically detects environment
const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3000/api/v1'
    }
    // Vercel branch previews (…-git-<branch>-….vercel.app) and the fixed
    // staging alias (…-staging.vercel.app) are the staging environment for
    // the public site — call the staging backend directly so features merged
    // to staging are testable before they exist on prod.
    // Real customer domains fall through to the same-origin proxy → prod.
    if (
      hostname.endsWith('.vercel.app') &&
      (hostname.includes('-git-') || hostname.includes('-staging'))
    ) {
      return 'https://relay-towing-backend-staging.up.railway.app/api/v1'
    }
  }
  // Same-origin Vercel proxy (vercel.json rewrites /api/* → Railway)
  return '/api/v1'
}

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log(`[API] ${config.method?.toUpperCase()} ${config.url}`)
    return config
  },
  (error) => {
    console.error('[API] Request error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error('[API] Response error:', error.response?.data || error.message)
    return Promise.reject(error)
  }
)

export default api
